export default "__VITE_ASSET__CqUkcqgK__"